'use client';

import { useRouter } from 'next/navigation';
import { Button } from '@heroui/react';
import type { ComponentProps } from 'react';

type ButtonProps = ComponentProps<typeof Button>;

type LinkButtonProps = ButtonProps & {
  href: string;
};

/**
 * A Button that navigates to an href using Next.js router.
 * Uses onPress + router.push to avoid invalid <a><button> nesting
 * which caused react-aria ID hydration mismatches.
 */
export function LinkButton({ href, children, onPress, ...props }: LinkButtonProps) {
  const router = useRouter();

  return (
    <Button
      {...props}
      onPress={(e) => {
        router.push(href);
        onPress?.(e);
      }}
    >
      {children}
    </Button>
  );
}
